<template>
  <section class="wt-countdown">
    <div class="wt-countdown-inner">
      <vue-countdown-timer
        class="countdown"
        label-position="begin"
        :interval="1000"
        :start-time="'2019-10-10 00:00:00'"
        :start-label="'Until start:'"
        :end-time="countdownEndTime"
        :end-text="countdownEndMessage"
        :day-txt="countdownDaysText"
        :hour-txt="countdownHoursText"
        :minutes-txt="countdownMinutesText"
        :seconds-txt="countdownSecondsText"
        @start_callback="startCallBack('event started')"
        @end_callback="endCallBack('event ended')"
      >
        <template
          slot="start-label"
          slot-scope="scope"
        >
          <span
            v-if="
              scope.props.startLabel !== '' &&
                scope.props.tips &&
                scope.props.labelPosition === 'begin'
            "
            style="color: red"
          >{{ scope.props.startLabel }}:</span>
          <span
            v-if="
              scope.props.endLabel !== '' &&
                !scope.props.tips &&
                scope.props.labelPosition === 'begin'
            "
            style="color: blue"
          >{{ scope.props.endLabel }}:</span>
        </template>

        <template
          slot="countdown"
          slot-scope="scope"
        >
          <p class="countdown-intro">
            {{ countdownIntroText }}
          </p>
          <div class="countdown-timeslot-wrapper">
            <div class="countdown-timeslot">
              <span class="countdown-timeslot-number">{{ scope.props.days }}</span>
              <span class="countdown-timeslot-text">{{ scope.props.dayTxt }}</span>
            </div>
            <div class="countdown-timeslot-divider">
              :
            </div>
            <div class="countdown-timeslot">
              <span class="countdown-timeslot-number">{{ scope.props.hours }}</span>
              <span class="countdown-timeslot-text">{{ scope.props.hourTxt }}</span>
            </div>
            <div class="countdown-timeslot-divider">
              :
            </div>
            <div class="countdown-timeslot">
              <span class="countdown-timeslot-number">{{ scope.props.minutes }}</span>
              <span class="countdown-timeslot-text">{{ scope.props.minutesTxt }}</span>
            </div>
            <div class="countdown-timeslot-divider">
              :
            </div>
            <div class="countdown-timeslot">
              <span class="countdown-timeslot-number">{{ scope.props.seconds }}</span>
              <span class="countdown-timeslot-text">{{ scope.props.secondsTxt }}</span>
            </div>
          </div>
        </template>

        <template
          slot="end-label"
          slot-scope="scope"
        >
          <span
            v-if="
              scope.props.startLabel !== '' &&
                scope.props.tips &&
                scope.props.labelPosition === 'end'
            "
          >{{ scope.props.startLabel }}:</span>
          <span
            v-if="
              scope.props.endLabel !== '' &&
                !scope.props.tips &&
                scope.props.labelPosition === 'end'
            "
          >{{ scope.props.endLabel }}:</span>
        </template>

        <template
          slot="end-text"
          slot-scope="scope"
        >
          <span class="text-white">{{ scope.props.endText }}</span>
        </template>
      </vue-countdown-timer>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WelcomeCountdown',
  props: {
    countdownIntroText: {
      type: String,
      default: '',
    },
    countdownEndTime: {
      type: String,
      default: '',
    },
    countdownEndMessage: {
      type: String,
      default: '',
    },
    countdownDaysText: {
      type: String,
      default: 'Days',
    },
    countdownHoursText: {
      type: String,
      default: 'Hours',
    },
    countdownMinutesText: {
      type: String,
      default: 'Minutes',
    },
    countdownSecondsText: {
      type: String,
      default: 'Seconds',
    },
  },
  methods: {
    startCallBack: function(x) {
      console.log(x);
    },
    endCallBack: function(x) {
      console.log(x);
    },
  },
};
</script>

<style lang="postcss">
.wt-countdown {
  @apply w-full bg-white pt-14 relative;

  &-inner {
    @apply container mx-auto relative flex justify-center;
    z-index: 1;
  }

  .countdown {
    @apply flex flex-col justify-center rounded-lg p-8 bg-primary-bravo;

    &-intro {
      @apply text-center text-white text-2xl;

      @screen md {
        @apply text-4xl;
      }
    }

    &-timeslot {
      @apply flex flex-col items-center;
      min-width: 60px;

      @screen md {
        min-width: 80px;
      }

      &-wrapper {
        @apply flex justify-center;
      }

      &-number,
      &-divider {
        @apply text-white text-3xl;

        @screen md {
          @apply text-10xl;
        }
      }

      &-text {
        @apply text-black text-base;
      }
    }
  }
}
</style>
